<div class="main-view">
  <router-outlet></router-outlet>
</div>

<div class="faded-gradient-bg" *ngIf="showFadedBg === true"></div>
<nav class="navbar navbar-expand-md navbar-light fixed-top">
  <a class="navbar-brand logo">
    <img [src]="logoImage" width="82" />
  </a>
  <button (click)="toggleMobileMenu()" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div id="mobile-menu" class="collapse navbar-collapse">
    <ul class="navbar-nav mr-auto">
      <ng-template ngxPermissionsOnly="main_menu.enable_discover">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/discover']" [queryParams]="{activeAccount: currentCompanyId}" [routerLinkActive]="['active']">Discover</a>
        </li>
      </ng-template>
      <ng-template ngxPermissionsOnly="main_menu.enable_groups">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/groups']" [queryParams]="{activeAccount: currentCompanyId}" [routerLinkActive]="['active']">Influencers</a>
        </li>
      </ng-template>
      <ng-template ngxPermissionsOnly="main_menu.enable_campaigns">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/campaigns']" [queryParams]="{activeAccount: currentCompanyId}" [routerLinkActive]="['active']">Campaigns</a>
        </li>
      </ng-template>
      <ng-template ngxPermissionsOnly="main_menu.enable_measure">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/measure']" [queryParams]="{activeAccount: currentCompanyId}" [routerLinkActive]="['active']">Measure</a>
        </li>
      </ng-template>
      <ng-template *ngIf="!isDisableInboxPage" ngxPermissionsOnly="main_menu.enable_inbox">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/inbox']" [queryParams]="{activeAccount: currentCompanyId}" [routerLinkActive]="['active']">Inbox</a>
        </li>
      </ng-template>
    </ul>
  </div>
</nav>
<div class="sidebar">
  <ul class="menu">
    <li class="logo">
      <img [src]="logoImage" />
    </li>
    <ng-template ngxPermissionsOnly="main_menu.enable_discover">
      <li>
        <a class="sidebar-icon" [routerLink]="['/discover']"
           placement="right" ngbTooltip="{{'info_box.discover.sidebar' | translate}}"
           [queryParams]="{activeAccount: currentCompanyId}" [routerLinkActive]="['active']">
          <svg viewBox="0 0 39 39" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.27 35.282c.998-.527 1.1-1.208 2.005-1.246 1.037-.047 1.88-.404 3.047-.66 1.037-.227 2.89-1.278 4.524-1.414 1.375-.112 4.092.073 4.824 1.401a16.53 16.53 0 0 1-9.17 2.768c-1.828 0-3.584-.3-5.23-.849m2.945-32.248c-.398.775-1.447 1.09-2.087 1.672-1.387 1.257-1.984 1.083-2.733 2.29-.753 1.205-3.182 2.944-3.182 3.817 0 .87 1.227 1.901 1.84 1.7.614-.2 2.23-.19 3.183.144.952.337 7.95.673 5.721 6.59-.706 1.88-3.804 1.563-4.63 4.68-.122.455-.55 2.407-.58 3.046-.05.986.699 4.708-.253 4.708-.957 0-3.53-3.328-3.53-3.931 0-.603-.668-2.72-.668-4.53 0-1.811-3.08-1.782-3.08-4.19 0-2.173 1.67-3.252 1.294-4.293-.368-1.035-3.305-1.073-4.528-1.198C6.12 7.992 11.151 3.872 17.215 3.034M36.13 19.5c0 3.804-1.29 7.313-3.445 10.119-.61-.479-1.257-1.764-.648-3.096.614-1.341.775-4.444.635-5.652-.135-1.205-.761-4.115-2.467-4.143-1.7-.025-2.869-.588-3.88-2.606-2.099-4.2 3.94-5.007 1.84-7.334-.587-.652-3.622 2.689-4.066-1.764-.03-.316.275-.793.681-1.287 6.59 2.213 11.35 8.44 11.35 15.763M19.5 0C8.747 0 0 8.75 0 19.5 0 30.253 8.747 39 19.5 39S39 30.253 39 19.5C39 8.75 30.253 0 19.5 0" fill="#95a0b1" fill-rule="evenodd"/>
          </svg>
        </a>
      </li>
    </ng-template>
    <ng-template ngxPermissionsOnly="main_menu.enable_groups">
      <li>
        <a class="sidebar-icon" [routerLink]="['/groups']"
           placement="right" ngbTooltip="{{'info_box.influencer_group.sidebar' | translate}}"
           [queryParams]="{activeAccount: currentCompanyId}" [routerLinkActive]="['active']">
          <svg viewBox="0 0 105 105" xmlns="http://www.w3.org/2000/svg">
            <path d="M81.034 23.97c-7.571-7.572-9.473-17.562-8.808-18.236.677-.675 10.278 1.62 17.85 9.19 7.572 7.574 9.835 17.19 9.194 17.844-.654.652-10.676-1.227-18.236-8.799zm-39.387 34.6c-2.17-2.174-1.458-6.399 1.575-9.439 3.045-3.038 7.269-3.746 9.439-1.573 2.17 2.17 1.47 6.4-1.575 9.439-3.034 3.037-7.269 3.742-9.439 1.572zm52.36-47.577C84.232 1.221 71.958-2.354 68.05 1.555L52.322 17.284c-2.38 2.387-4.468 10.372-3.511 18.456L1.21 83.346C-1.614 86.17.673 93.035 6.32 98.68c5.647 5.648 12.507 7.936 15.33 5.114l47.613-47.607c8.085.954 16.065-1.128 18.456-3.513l15.727-15.73c3.909-3.907.327-16.177-9.438-25.95z" fill="#95a0b1" fill-rule="evenodd"/>
          </svg>
          <div class="pending-influencer-indicator" *ngIf="showPendingInfluencerIndicator"></div>
        </a>
      </li>
    </ng-template>
    <ng-template ngxPermissionsOnly="main_menu.enable_campaigns">
      <li>
        <a class="sidebar-icon" [routerLink]="['/campaigns']"
           placement="right" ngbTooltip="{{'info_box.campaign.sidebar' | translate}}"
           [queryParams]="{activeAccount: currentCompanyId}" [routerLinkActive]="['active']">
          <svg viewBox="0 0 105 111" xmlns="http://www.w3.org/2000/svg">
            <path d="M93.228 73.821c-1.748.716-13.504-8.624-21.018-26.235-7.511-17.607-6.567-33.705-4.821-34.42 1.745-.714 13.212 10.552 20.725 28.16 7.511 17.607 6.863 31.78 5.114 32.495m3.365-36.75C86.926 14.42 71.371-2.835 63.5.389c-13.366 5.47 7.963 31.749-57.67 58.62-5.669 2.32-7.106 11.61-4.733 17.163 2.368 5.553 10.122 11.08 15.794 8.759.979-.401 4.583-1.568 4.583-1.568 4.049 5.472 8.286 2.226 9.788 5.703 1.806 4.18 5.735 13.263 7.068 16.355 1.338 3.088 4.366 5.948 6.565 5.107 2.192-.841 9.658-3.703 12.515-4.797 2.854-1.095 3.537-3.658 2.664-5.68-.943-2.18-4.801-2.82-5.9-5.362-1.102-2.545-4.698-10.694-5.733-13.263-1.407-3.494 1.58-6.336 5.921-6.79 29.873-3.137 35.457 15.445 45.628 11.28 7.871-3.223 6.27-26.189-3.396-48.843" fill="#95a0b1" fill-rule="evenodd"/>
          </svg>
        </a>
      </li>
    </ng-template>
    <ng-template ngxPermissionsOnly="main_menu.enable_measure">
      <li>
        <a class="sidebar-icon" [routerLink]="['/measure']"
           placement="right" ngbTooltip="{{'info_box.measure.sidebar' | translate}}"
           [queryParams]="{activeAccount: currentCompanyId}" [routerLinkActive]="['active']">
          <svg viewBox="0 0 105 70" xmlns="http://www.w3.org/2000/svg">
            <path d="M90.397 19.624a710.092 710.092 0 0 1-4.378 11.424c5.338 7.717 8.481 17.398 8.481 28.035 0 1.659-.075 3.328-.224 4.966a5.247 5.247 0 0 0 4.753 5.702c.162.01.321.02.482.02a5.25 5.25 0 0 0 5.222-4.777c.177-1.942.267-3.927.267-5.911 0-15.498-5.525-29.337-14.603-39.46zM52.5 13.072c2.295 0 4.538.2 6.724.567a681.835 681.835 0 0 1 7.382-9.072A50.758 50.758 0 0 0 52.5 2.572C23.061 2.572 0 27.394 0 59.082c0 1.954.086 3.896.256 5.797.257 2.898 2.836 5.019 5.695 4.767a5.258 5.258 0 0 0 4.763-5.702 54.472 54.472 0 0 1-.214-4.861c0-25.799 18.449-46.011 42-46.011zm-9.831 39.9c-3.624 6.279-1.18 11.445 3.843 14.343 5.022 2.898 10.72 2.436 14.343-3.843C64.478 57.192 87.352 1.175 85.362.02c-1.992-1.144-39.07 46.673-42.693 52.952z" fill="#95a0b1" fill-rule="evenodd"/>
          </svg>
        </a>
      </li>
    </ng-template>
    <ng-template *ngIf="!isDisableInboxPage" ngxPermissionsOnly="main_menu.enable_inbox">
      <li>
        <a class="sidebar-icon" [routerLink]="['/inbox']"
           placement="right" ngbTooltip="{{'info_box.inbox.sidebar' | translate}}"
           [routerLinkActive]="['active']">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 27">
            <path
              d="M17.046 12.189L3.67 3.963h26.752zm13.376 11.517H3.67V7.253l13.376 8.227 13.376-8.227zm0-23.034H3.67C1.83.672.342 2.152.342 3.962L.325 23.707c0 1.81 1.505 3.29 3.345 3.29h26.752c1.84 0 3.344-1.48 3.344-3.29V3.963c0-1.81-1.505-3.29-3.344-3.29z"
              fill="#95a0b1" fill-rule="evenodd"/>
          </svg>
        </a>
      </li>
    </ng-template>
  </ul>
  <ul class="activated-influencer-area">
    <li>{{'user.menu.activated_influencers' | translate}} 
      <ng-container *ngIf="activatedInfluencersData">{{activatedInfluencersData.activatedInfluencers}}/{{activatedInfluencersData.maxActivatedInfluencers}}</ng-container>
      <ng-container *ngIf="!activatedInfluencersData">-/-</ng-container>
    </li>
  </ul>
  <ul class="bottom">
    <li>
      <a [popper]="userNavigationPopper"
         [popperTrigger]="'click'"
         [popperHideOnClickOutside]="true"
         (popperOnShown)="popperOnShown($event)"
         (popperOnHidden)="popperOnHidden($event)"
         [popperDisableAnimation]="false"
         [popperApplyClass]="'ngx-popper, white'"
         [popperApplyArrowClass]="'ngx-popper-arrow'"
         [popperPlacement]="'right-end'">
        <div class="helper"><img class="user-avatar" [src]="userAvatar" alt=""/></div>
      </a>
      <popper-content #userNavigationPopper>
        <ul class="user-menu">
          <li class="header">{{'user.menu.user_navigation' | translate}}</li>
          <ng-template ngxPermissionsOnly="user_menu.enable_billing">
            <li [routerLink]="['/user/billing']" [queryParams]="{activeAccount: currentCompanyId}"
                *ngIf="hasCreditBasedBilling"
                (click)="userNavigationPopper.hide()">{{'user.menu.billing' | translate}}</li>
          </ng-template>
          <ng-container *ngIf="!isSsoUser">
            <ng-template ngxPermissionsOnly="user_menu.enable_admin">
              <li
                (click)="changeAccountPopper.hide()"
                [popper]="manageUserPopper"
                [popperTrigger]="'click'"
                [popperHideOnClickOutside]="true"
                [popperDisableAnimation]="false"
                [popperApplyClass]="'ngx-popper, grey'"
                [popperApplyArrowClass]="'ngx-popper-arrow'"
                [popperPlacement]="'right-end'">
                {{'user.menu.admin' | translate}} ›
              </li>
            </ng-template>
            <li [routerLink]="['/account-settings']" [queryParams]="{activeAccount: currentCompanyId}"
                (click)="userNavigationPopper.hide()">{{'user.menu.account_settings' | translate}}</li>
            <ng-template ngxPermissionsOnly="user_menu.enable_admin">
              <li [routerLink]="['/admin/platform-settings']"
                  (click)="userNavigationPopper.hide()">{{'user.menu.platform_settings' | translate}} </li>
            </ng-template>
          </ng-container>
          <ng-template ngxPermissionsOnly="user_menu.enable_change_account">
            <li
              [popper]="changeAccountPopper"
              [popperTrigger]="'click'"
              [popperHideOnClickOutside]="false"
              [popperDisableAnimation]="false"
              [popperApplyClass]="'ngx-popper, grey'"
              [popperApplyArrowClass]="'ngx-popper-arrow'"
              [popperPlacement]="'right-end'"
              (popperOnShown)="openAccountList()"
              (popperOnHidden)="hideAccountList()">
              {{'user.menu.change_account' | translate}} ›
            </li>
          </ng-template>
          <li (click)="openIntercom()" (click)="userNavigationPopper.hide()">{{'user.menu.support' | translate}}</li>
          <li (click)="userNavigationPopper.hide()"><a href="{{faqLink}}" target="_blank" class="poper-link">{{'user.menu.fqa' | translate}}</a></li>
          <li (click)="logout()">{{'user.menu.log_out' | translate}}</li>
        </ul>
        <popper-content #changeAccountPopper>
          <ul class="user-menu grey account-list" *ngIf="showAccountList">
            <li class="header">{{'user.menu.change_account' | translate}}</li>
            <li *ngFor="let comp of companyList; trackBy: trackByFn"
                class="ellipsis"
                [ngClass]="{'selected': currentCompanyId === comp.id}"
                (click)="changeAccountPopper.hide()"
                (click)="changeAccount(comp.id)">{{comp.name}}</li>
          </ul>
        </popper-content>
        <popper-content #manageUserPopper>
          <ul class="user-menu grey account-list">
            <li class="header">{{'user.menu.manage_user' | translate}}</li>
            <ng-template ngxPermissionsOnly="user_menu.enable_admin">
              <li [routerLink]="['/framed/admin']" (click)="userNavigationPopper.hide()">{{'user.menu.old_admin' | translate}}</li>
            </ng-template>
            <ng-template ngxPermissionsOnly="user_menu.enable_admin" *ngIf="isEnableInfluencerReviewFeature()">
              <li [routerLink]="['/admin/influencer-review']" (click)="userNavigationPopper.hide()">{{'user.menu.influencer_review' | translate}}</li>
            </ng-template>
          </ul>
        </popper-content>
      </popper-content>
    </li>
  </ul>
</div>


<achoo-popup #InvalidActionByLevelWarning
             [isNotification]="false"
             [isSpecialPopup]="true"
             (closeCallback)="closeWallNotification('Close Icon')">
  <invalid-account-level-notification
    [message]="invalidLevelMsg"
    [needToUpgrade]="needToUpgradeAccount"
    (openContactSupport)="contactSupport()"
    (upgradeAccountEvt)="upgradeAccount($event)" >
  </invalid-account-level-notification>
</achoo-popup>
<achoo-popup #SupportForm [isNotification]="false" class="support-popup">
  <support-form></support-form>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/main.component.html